import { IMAGES } from "../../constants/images";
import styled from "styled-components";

export default function Logo({ isMobile = false }) {
  return (
    <StyledLogo isMobile={isMobile}>
      <img src={IMAGES.LOGO} alt="logo" />
      <h2 className="text">
        Defensible <span>space</span> viewer
      </h2>
    </StyledLogo>
  );
}

const StyledLogo = styled.div`
  display: ${({ isMobile }) => (isMobile ? "grid" : "flex")};
  align-items: center;
  gap: 10px;
  margin-top: ${({ isMobile }) => (isMobile ? "25px" : "0")};

  img {
    height: ${({ isMobile }) => (isMobile ? "80px" : "100px")};
  }

  .text {
    margin: 0;
    text-transform: uppercase;
    font-size: ${({ isMobile }) => (isMobile ? "42px" : "36px")};
    font-weight: 700;
    letter-spacing: 2px;
    span {
      color: rgba(0, 0, 255, 1);
    }
  }
`;
